import axios from 'axios'
import store from '@/store'
import _ from 'lodash'

export default {
  async getAll () {
    if (!store.getters.getCategories.length) {
      let response = await axios.get(store.getters.getProductV2Api + '/categories?company_id=' + store.getters.getChoiceCompanyId)
      store.state.categories = []
      if (response.data){
        // response.data = response.data.filter(c => !c.parent_id)
        // response.data.sort((a, b) => {
        //   return a.order - b.order
        // })
        // console.log(response.data)
        store.state.categories = this.removeParentWithChildren(response.data)
      }
      let resp = {data: []}
      resp.data = await store.getters.getCategories
      return resp
    } else {
      console.log('categories from cache')
      let response = {data: []}
      response.data = await store.getters.getCategories
      return response
    }
  },

  removeParentWithChildren (categories) {
    console.log(categories)
    let categoriesParent = categories.filter(c => !c.parent_id)
    let categoriesChildren = categories.filter(c => c.parent_id)
    let categoriesWithoutChildren = []
    categoriesParent.forEach((p) => {
      let filtered = categoriesChildren.filter(c => c.parent_id === p.id)
      if(filtered.length === 0 ){
        categoriesWithoutChildren.push(p)
      } else {
        filtered.forEach((f) => {
          f.name = p.name + ' - ' + f.name
        })
      }
    })
    return _.union(categoriesChildren, categoriesWithoutChildren)
  },


}